import React, { useState, useEffect } from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";
import DataTable from "../../table/DataTable";
import CommonInput from "../../Input/CommonInput";
import CommonButton from "../../Input/CommonButton";
import CommonDatePicker from "../../Input/CommonDatePicker";
import TopupDetailsModal from "./TopupDetailsModal";

const TopupTable = ({ data = [] }) => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [transactionId, setTransactionId] = useState("");

  const [filteredData, setFilteredData] = useState(data);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  // Get current items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [showDetails, setShowDetails] = useState(false);
  const [selectedTx, setSelectedTx] = useState(null);

  useEffect(() => {
    setFilteredData(data);
    setCurrentPage(1);
  }, [data]);

  const parseDate = (dateStr) => {
    const [datePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("/");
    return new Date(year, month - 1, day);
  };

  const handleSearch = () => {
    let results = data;

    if (transactionId) {
      results = results.filter((item) =>
        item.id.toLowerCase().includes(transactionId.toLowerCase()),
      );
    }

    if (fromDate) {
      results = results.filter((item) => {
        const itemDate = parseDate(item.createdTime);
        return itemDate >= fromDate;
      });
    }

    if (toDate) {
      results = results.filter((item) => {
        const itemDate = parseDate(item.createdTime);
        return itemDate <= toDate;
      });
    }

    setFilteredData(results);
    setCurrentPage(1);
  };

  const handleReset = () => {
    setTransactionId("");
    setFromDate(null);
    setToDate(null);
    setFilteredData(data);
    setCurrentPage(1);
  };

  const columns = [
    {
      label: "Transaction ID",
      key: "id",
      style: { width: "80px" },
      className: "ps-4",
    },
    {
      label: "Created time",
      key: "createdTime",
      className: "ps-2",
    },
    {
      label: "Type",
      key: "type",
      className: "ps-4",
    },
    {
      label: "Customer",
      key: "customer",
      className: "ps-4",
      render: (item) => (
        <div>
          <div className="fw-bold text-black">{item.customer.name}</div>
          <div className="text-muted fs-12">{item.customer.email}</div>
        </div>
      ),
    },
    {
      label: "Amount",
      key: "amount",
      className: "ps-4",
    },
    {
      label: "Status",
      key: "status",
      className: "ps-2",
      render: (item) => (
        <Badge
          bg={item.status === "Approved" ? "success" : "warning"}
          className={`rounded-2 py-1 px-2 ${
            item.status === "Approved" ? "bg-opacity-100" : "text-white"
          }`}
          style={{
            backgroundColor: item.status === "Approved" ? "#006B44" : "#F3A01C",
          }}
        >
          {item.status}
        </Badge>
      ),
    },
    {
      label: "Action",
      key: "action",
      className: "ps-2",
      render: (item) => (
        <div
          className="cursor-pointer hover-primary"
          onClick={() => {
            setSelectedTx(item);
            setShowDetails(true);
          }}
        >
          <i className="far fa-eye text-secondary fs-16"></i>
        </div>
      ),
    },
  ];

  return (
    <div className="mt-4">
      <Card className="border-0 shadow-sm rounded-4 mb-4">
        <Card.Body className="p-4">
          <Row className="align-items-end g-3">
            <Col xl={3} lg={4} md={6}>
              <label className="fw-bold text-black mb-2">Transaction ID</label>
              <CommonInput
                placeholder="Enter transaction ID"
                value={transactionId}
                onChange={(e) => setTransactionId(e.target.value)}
              />
            </Col>
            <Col xl={3} lg={4} md={6}>
              <CommonDatePicker
                label="From date"
                selected={fromDate}
                onChange={(date) => setFromDate(date)}
                placeholderText="Select from date"
              />
            </Col>
            <Col xl={3} lg={4} md={6}>
              <CommonDatePicker
                label="To date"
                selected={toDate}
                onChange={(date) => setToDate(date)}
                placeholderText="Select to date"
              />
            </Col>
            <Col xl={3} lg={12} className="d-flex gap-2">
              <CommonButton
                variant="outline"
                onClick={handleReset}
                className="p-0 d-flex align-items-center justify-content-center"
                style={{ width: "50px", height: "50px", minWidth: "50px" }}
              >
                <i className="flaticon-381-repeat-1"></i>
              </CommonButton>
              <CommonButton
                onClick={handleSearch}
                className="p-0 d-flex align-items-center justify-content-center"
                style={{ width: "50px", height: "50px", minWidth: "50px" }}
              >
                <i className="flaticon-381-search-1 fs-20"></i>
              </CommonButton>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
        <div className="card-body">
          <DataTable
            columns={columns}
            data={currentItems}
            totalItems={filteredData.length}
            itemsPerPage={itemsPerPage}
            currentPage={currentPage}
            paginate={paginate}
            showPagination={true}
            minWidth="100%"
          />
        </div>
      </div>

      <TopupDetailsModal
        show={showDetails}
        onHide={() => setShowDetails(false)}
        transaction={selectedTx}
      />

      <style>{`
        .bg-light { background-color: #f8f9fa !important; }
        .fs-12 { font-size: 12px; }
        .fs-18 { font-size: 18px; }
        .hover-primary:hover { color: var(--primary) !important; }
      `}</style>
    </div>
  );
};

export default TopupTable;
